

// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { useAuthState } from 'react-firebase-hooks/auth';
// import auth from "../../firebase.init"; 
// import { useNavigate } from 'react-router-dom';

// // NOTE: SCRIPT_GENERATION_MODEL (Gemini) is used to create the detailed blueprint (JSON script).
// const SCRIPT_GENERATION_MODEL = "gemini-2.0-flash"; 

// // HYPOTHETICAL: This simulates the backend service that calls Veo 3.
// const VEO_3_SYNTHESIS_COST = 5; // Higher cost for video generation

// const ProductPhotographyVideoAI = () => {
//     // --- Authentication and State Management ---
//     const [user, loadingAuth] = useAuthState(auth);
//     const [loading, setLoading] = useState(true);
//     const [loadingKeys, setLoadingKeys] = useState(true);
//     const [generating, setGenerating] = useState(false);
//     const [error, setError] = useState("");
//     const [success, setSuccess] = useState("");
//     const [credits, setCredits] = useState(0);
//     const navigate = useNavigate();

//     // --- Component-specific state ---
//     const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//     const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//     const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
    
//     // Video-specific options
//     const [selectedVideoStyle, setSelectedVideoStyle] = useState("Social Media Ad (Short)"); 
//     const [customPrompt, setCustomPrompt] = useState("");
    
//     // Holds the final output: either the JSON script (during the first step) or the Video URL (final step)
//     const [generatedVideoOutput, setGeneratedVideoOutput] = useState(""); 
//     const [apiKeys, setApiKeys] = useState([]);
    
//     // --- Data Fetching Logic (Retained from original) ---
//     useEffect(() => {
//         const fetchData = async () => {
//             if (loadingAuth) return;
//             if (!user) {
//                 setLoading(false);
//                 setLoadingKeys(false);
//                 return;
//             }

//             try {
//                 await fetchApiKeys();
//                 // Fetching user data (credits)
//                 const userResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/users`, {
//                     params: { userEmail: user.email },
//                 });
//                 if (userResponse.data && userResponse.data.length > 0) {
//                     setCredits(userResponse.data[0].currentBalance);
//                 } else {
//                     setError("User data not found");
//                 }
//             } catch (err) {
//                 console.error(err);
//                 setError("Failed to load data");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchData();
//     }, [user, loadingAuth]);

//     const fetchApiKeys = async () => {
//         try {
//             const response = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/gemini-keys`);
//             if (response.data?.success && response.data.data) {
//                 setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//             } else {
//                 setError("Failed to load API keys");
//             }
//         } catch (err) {
//             console.error(err);
//             setError("Error loading API keys");
//         } finally {
//             setLoadingKeys(false);
//         }
//     };

//     const getRandomApiKey = () => {
//         if (apiKeys.length === 0) throw new Error("No API keys available");
//         return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//     };

//     const handleImageUpload = (e) => {
//         if (e.target.files && e.target.files[0]) {
//             const file = e.target.files[0];
//             const reader = new FileReader();

//             reader.onload = () => {
//                 const base64DataUrl = reader.result;
//                 setUploadedImageUrl(base64DataUrl);
//                 setUploadedImageBase64(base64DataUrl.split(",")[1]);
//                 setUploadedImageMimeType(file.type);
//             };

//             reader.readAsDataURL(file);
//         }
//     };

//     // --- Step 2: Simulated Veo 3 Video Synthesis ---
//     const startVideoSynthesis = async (scriptData) => {
//         // Video synthesis costs 5 credits, Script cost (1) was deducted in the previous step.
//         const TOTAL_COST = VEO_3_SYNTHESIS_COST; 
        
//         // This is a placeholder for a REAL long-running video generation job.
//         // It should happen on a robust backend/queue for real Veo integration.
//         setSuccess(`Script created. Starting Veo 3 Video Synthesis (Wait Time: ~10 seconds simulation)...`);
        
//         try {
//             // --- 1. Deduct Video Synthesis Credit (5 credits) ---
//             const deductVideoResponse = await axios.post(
//                 `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
//                 { userEmail: user.email, amount: TOTAL_COST }
//             );
//             if (!deductVideoResponse.data.success) {
//                 throw new Error("Failed to deduct video synthesis credits");
//             }
//             setCredits((prev) => prev - TOTAL_COST);
            
//             // --- 2. Simulate Veo 3 API Call & Wait ---
//             // In a real app, this would be an async background job.
//             // Here, we simulate a 10-second wait for the "generation" time.
//             await new Promise(resolve => setTimeout(resolve, 10000)); 

//             // HYPOTHETICAL API RESPONSE
//             const mockVideoUrl = scriptData.videoPlaceholderLink 
//                 ? scriptData.videoPlaceholderLink.replace("placeholder", "final-veo3-product")
//                 : "https://mock-video-cdn.com/veo3-ad-final.mp4"; // Mock video URL

//             // The actual final product of the entire process is the URL
//             setGeneratedVideoOutput(mockVideoUrl); 
//             setSuccess(`✅ Video synthesis complete! View your 8-second video below.`);

//         } catch (err) {
//             console.error("Video Synthesis Error:", err);
//             setError(`Veo 3 Synthesis Failed: ${err.message}. ${TOTAL_COST} credits refunded.`);
            
//             // Refund the high synthesis cost on failure
//             try {
//                 await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: TOTAL_COST });
//                 setCredits((prev) => prev + TOTAL_COST);
//             } catch (refundErr) {
//                 console.error("Failed to refund video credit:", refundErr);
//             }
//         } finally {
//             setGenerating(false);
//         }
//     };

//     // --- Step 1 & Main Handler: Generate Script + Start Video ---
//     const generateVideo = async () => {
//         // --- Pre-checks ---
//         if (!uploadedImageBase64) {
//             setError("Please upload a Product/UI image first.");
//             return;
//         }
//         const MIN_CREDITS_REQUIRED = 1 + VEO_3_SYNTHESIS_COST; // 1 for script + 5 for video
//         if (credits < MIN_CREDITS_REQUIRED) {
//             setError(`Insufficient credits. Need ${MIN_CREDITS_REQUIRED} credits (1 for script, ${VEO_3_SYNTHESIS_COST} for video)`);
//             return;
//         }

//         setGenerating(true);
//         setError("");
//         setSuccess("");
//         setGeneratedVideoOutput(""); 

//         try {
//             // 1. Deduct Script Credit (1 credit)
//             const scriptDeductionResponse = await axios.post(
//                 `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
//                 { userEmail: user.email, amount: 1 }
//             );
//             if (!scriptDeductionResponse.data.success) {
//                 throw new Error("Failed to deduct script credit");
//             }
//             setCredits((prev) => prev - 1);
//             setSuccess("Script credit deducted. Generating script blueprint...");

//             // 2. Prepare API Call
//             const API_URL = `https://generativelanguage.googleapis.com/v1/models/${SCRIPT_GENERATION_MODEL}:generateContent?key=${getRandomApiKey()}`;

//             let durationRange;
//             if (selectedVideoStyle.includes("Social Media Ad")) {
//                 durationRange = "8-10 seconds"; // Short duration as requested by the prompt ("8-second videos")
//             } else if (selectedVideoStyle.includes("Explainer Video")) {
//                 durationRange = "60-90 seconds";
//             } else {
//                 durationRange = "30-60 seconds";
//             }
            
//             // **New Prompt for Veo 3 Integration**
//             const prompt = `
// You are an expert video scriptwriter providing a detailed blueprint for the Veo 3 AI video generator. Convert the provided image (a product screenshot or UI/UX design) into a detailed video script for a **${selectedVideoStyle}** with **native audio generation (sound design and voiceover)**.

// INPUT:
// - Video Style/Type: ${selectedVideoStyle} 
// - Custom Instructions: ${customPrompt || "No extra instructions."}
// - Product/UI Image (source of inspiration)

// OUTPUT (JSON ONLY, Total duration must be **${durationRange}**):
// {
//     "title": "A short, engaging title for the video (e.g., 'Revolutionizing UI Design').",
//     "target_duration": "${durationRange}",
//     "script": [
//         {
//             "scene": 1,
//             "visuals": "Describe the scene, background, and precise camera movement. E.g., 'A clean, minimalist 3D environment. Smooth 4K dolly zoom on the product screen, highlighting the active user interaction. **Use sharp, high-contrast lighting.**'",
//             "voiceover": "The narration or on-screen text for this scene.",
//             "sound_design": "Detailed description of sound effects/music transition. E.g., 'Fast, clean whoosh sound effect, followed by an upbeat, cinematic beat drop.'",
//             "duration": "4 seconds"
//         },
//         {
//             "scene": 2,
//             "visuals": "Describe the final Call-to-Action scene, focusing on brand logo or product name.",
//             "voiceover": "Final call to action (e.g., 'Break the silence with Veo 3. Download Now!').",
//             "sound_design": "Music fades out with a final, crisp, digital chime.",
//             "duration": "4 seconds"
//         }
//     ],
//     "videoPlaceholderLink": "https://mock-video-cdn.com/placeholder-video.mp4",
//     "notes": "Suggest overall mood (e.g., 'futuristic and efficient.') and target audience."
// }

// REQUIREMENTS:
// 1. **Focus on native audio generation** by filling the 'sound_design' field with highly descriptive cues.
// 2. The video should have a clear **beginning (hook) and end (call to action)**.
// 3. Provide the output as a clean **JSON block only**, without any surrounding text or markdown.
// `;

//             const contents = [
//                 { role: "user", parts: [{ text: prompt }, { inlineData: { mimeType: uploadedImageMimeType, data: uploadedImageBase64 } }] },
//             ];

//             // 3. Call the API
//             const response = await fetch(API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ contents: contents }),
//             });

//             if (!response.ok) {
//                 throw new Error(`API Error: ${response.status}`);
//             }

//             const data = await response.json();
//             const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;
//             const jsonMatch = rawText?.match(/\{[\s\S]*\}/);
//             const jsonString = jsonMatch ? jsonMatch[0] : null;

//             if (!jsonString) {
//                 throw new Error("Generated text did not contain a valid JSON script.");
//             }
            
//             const generatedScript = JSON.parse(jsonString);

//             // 4. Start Video Synthesis with the generated script
//             await startVideoSynthesis(generatedScript);

//         } catch (err) {
//             console.error(err);
//             setError(`Error during Script Generation: ${err.message}`);
            
//             // Refund script credit (1 credit) on failure
//             try {
//                 await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: 1 });
//                 setCredits((prev) => prev + 1);
//             } catch (refundErr) {
//                 console.error("Failed to refund script credit:", refundErr);
//             }
//             setGenerating(false);
//         }
//     };

//     // --- Utility Functions (Retained) ---
//     const handleCopy = (content, type) => {
//         navigator.clipboard.writeText(content).then(() => {
//             setSuccess(`${type} copied to clipboard!`);
//             setTimeout(() => setSuccess(""), 3000);
//         }).catch((err) => {
//             setError("Failed to copy content.");
//             console.error("Copy failed", err);
//         });
//     };

//     // --- UI Rendering Logic (Updated for Video Output) ---
//     const renderPreview = () => {
//         if (generating) {
//             return (
//                 <div className="text-center py-5">
//                     <div className="ai-generating-animation">
//                         <div className="ai-icon mb-3">
//                             {/* SVG Icon for AI/Video */}
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
//                                 <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.216-2.779-1.643V5.653z" clipRule="evenodd" />
//                             </svg>
//                         </div>
//                         <p className="text-muted">AI is generating your **Video Script Blueprint** and starting **Veo 3 Synthesis**...</p>
//                         <div className="ai-dots"><span></span><span></span><span></span></div>
//                     </div>
//                 </div>
//             );
//         }

//         if (generatedVideoOutput.startsWith('http')) {
//             // Render the final video player
//             return (
//                 <div className="text-center p-3">
//                     <div className="video-player-frame">
//                         <video 
//                             controls 
//                             autoPlay 
//                             muted 
//                             loop
//                             src={generatedVideoOutput} 
//                             className="img-fluid rounded" 
//                             style={{ width: '100%', maxHeight: '400px', backgroundColor: '#000' }}
//                         >
//                             Your browser does not support the video tag.
//                         </video>
//                         <p className="mt-2 text-success fw-bold">Veo 3 Video Ready! (8 seconds)</p>
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="text-center text-muted py-5">
//                 <p>The final synthesized **8-second video** will appear here after the Veo 3 process is complete.</p>
//             </div>
//         );
//     };

//     // --- Loading/Auth Checks (Retained) ---
//     if (loadingAuth || loading || loadingKeys)
//         return (
//             <div className="d-flex justify-content-center align-items-center vh-100">
//                 <div className="spinner-border text-primary" role="status" style={{ width: "4rem", height: "4rem" }}>
//                     <span className="visually-hidden">Loading...</span>
//                 </div>
//             </div>
//         );

//     if (!user)
//         return (
//             <div className="container text-center py-5">
//                 <h2>Please log in to use the Image to Video AI tool</h2>
//                 <button className="btn btn-primary mt-3" onClick={() => (window.location.href = "/login")}>
//                     Go to Login
//                 </button>
//             </div>
//         );

//     // --- Main Render (Refactored JSX) ---
//     return (
//         <div className="container py-5">
//             <div className="row g-4">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//                             Image to <span style={{ color: "#00bfa5" }}>Veo 3 Video AI 🎬</span>
//                         </h2>
//                         <h4 className="mb-4  text-black">Remaining Credits: <span className="text-primary">{credits}</span></h4>
//                         <p className="text-muted mb-3">**Veo 3 Synthesis Cost: 6 Credits Total** (1 Script + 5 Video)</p>

//                         {credits < 6 && (
//                             <button className="btn btn-danger btn-sm mb-3" onClick={() => navigate("/user/select-package")}>
//                                 Buy More Credits
//                             </button>
//                         )}
//                         {error && <div className="alert alert-danger">{error}</div>}
//                         {success && <div className="alert alert-success">{success}</div>}

//                         {/* --- Input Section --- */}
//                         <div className="mb-3 mt-3">
//                             <label className="form-label fw-bold">1. Upload Product/UI Image *</label>
//                             <input
//                                 id="image-upload-input"
//                                 type="file"
//                                 className="form-control"
//                                 accept="image/*"
//                                 onChange={handleImageUpload}
//                                 disabled={generating}
//                             />
//                             {uploadedImageUrl && (
//                                 <div className="mt-3 text-center border p-2 rounded bg-light">
//                                     <img
//                                         src={uploadedImageUrl}
//                                         alt="Uploaded Preview"
//                                         className="img-fluid rounded"
//                                         style={{ maxHeight: "150px" }}
//                                     />
//                                 </div>
//                             )}
//                         </div>

//                         <div className="mb-3">
//                             <label className="form-label fw-bold">2. Select Video Style/Type (For 8-second focus)</label>
//                             <select
//                                 className="form-select"
//                                 value={selectedVideoStyle}
//                                 onChange={(e) => setSelectedVideoStyle(e.target.value)}
//                                 disabled={generating}
//                             >
//                                 <option value="Social Media Ad (Short)">Social Media Ad (Target 8-10 sec)</option>
//                                 <option value="Cinematic Trailer">Cinematic Trailer (Target 8-10 sec)</option>
//                                 <option value="Quick Demo">Quick Demo (Target 8-10 sec)</option>
//                             </select>
//                         </div>

//                         <div className="mb-4">
//                             <label className="form-label fw-bold">
//                                 3. Custom Instructions (e.g., Focus on 'dark mode', Use inspiring music)
//                             </label>
//                             <textarea
//                                 className="form-control"
//                                 value={customPrompt}
//                                 onChange={(e) => setCustomPrompt(e.target.value)}
//                                 placeholder="e.g., Target audience is young developers. Keep the tone inspiring and fast-paced. Highlight feature X."
//                                 rows={2}
//                                 disabled={generating}
//                             />
//                         </div>

//                         <div className="d-grid gap-2 mb-4">
//                             <button
//                                 className="btn btn-primary btn-lg"
//                                 onClick={generateVideo}
//                                 disabled={generating || !uploadedImageBase64 || credits < 6}
//                             >
//                                 {generating ? (
//                                     <>
//                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                         Generating with Veo 3...
//                                     </>
//                                 ) : (
//                                     "Break the silence with Veo 3 (6 Credits)"
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* --- Output Section --- */}
//             <div className="row g-4 mt-2">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h5 className="m-0 mb-3 text-primary">Veo 3 Video Output</h5>
                        
//                         {/* Video Player/Mockup */}
//                         {renderPreview()}

//                         {/* Only show "Download" if a video URL is available */}
//                         {generatedVideoOutput.startsWith('http') && (
//                             <div className="mt-4 pt-3 border-top text-center">
//                                 <a
//                                     href={generatedVideoOutput}
//                                     className="btn btn-success btn-sm"
//                                     download="veo3_product_video.mp4"
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                 >
//                                     Download Final Video (.mp4)
//                                 </a>
//                             </div>
//                         )}

//                     </div>
//                 </div>
//             </div>

//             {/* --- Style Block (CSS for Animations/Layout) --- */}
//             <style jsx>{`
//                 .video-player-frame {
//                     width: 100%;
//                     aspect-ratio: 16/9; /* Standard video aspect ratio */
//                     background-color: #000;
//                     border-radius: 8px;
//                     margin: 20px auto 0;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     justify-content: center;
//                     box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
//                 }
//                 .ai-generating-animation { /* ... (animations retained for visual feedback) ... */ }
//                 .ai-icon svg { width: 4rem; height: 4rem; color: #00bfa5; animation: pulse 2s infinite; }
//                 @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
//                 .ai-dots { display: flex; justify-content: center; margin-top: 10px; }
//                 .ai-dots span { width: 10px; height: 10px; background-color: #00bfa5; border-radius: 50%; margin: 0 5px; display: inline-block; animation: bounce 1.4s infinite ease-in-out both; }
//                 .ai-dots span:nth-child(1) { animation-delay: -0.32s; }
//                 .ai-dots span:nth-child(2) { animation-delay: -0.16s; }
//                 @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
//             `}</style>
//         </div>
//     );
// };

// export default ProductPhotographyVideoAI;



// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { useAuthState } from 'react-firebase-hooks/auth';
// // NOTE: These imports assume you have standard Firebase and React Router setup
// import auth from "../../firebase.init"; 
// import { useNavigate } from 'react-router-dom';

// // Configuration Constants
// const GEMINI_PLANNING_MODEL = "gemini-2.0-flash"; // Used for intelligent scripting/planning
// const VEO_GENERATION_MODEL_ID = "veo-3.0-generate-001"; // Placeholder for the actual Veo 3 model
// const VEO_SYNTHESIS_COST = 1; // Total cost for the final video output, as requested (1 credit)

// // NOTE on Mock Video: We use a public, working MP4 link here because the Veo 3 API 
// // cannot be called directly from a client-side React app. This ensures the video player loads correctly.
// const FALLBACK_MOCK_VIDEO_URL = "https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4"; 

// const ProductPhotographyVideoAI = () => {
//     // --- Authentication and State Management ---
//     const [user, loadingAuth] = useAuthState(auth);
//     const [loading, setLoading] = useState(true);
//     const [loadingKeys, setLoadingKeys] = useState(true);
//     const [generating, setGenerating] = useState(false);
//     const [error, setError] = useState("");
//     const [success, setSuccess] = useState("");
//     const [credits, setCredits] = useState(0);
//     const navigate = useNavigate();

//     // --- Component-specific state ---
//     const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//     const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//     const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
    
//     // Video-specific options
//     const [selectedVideoStyle, setSelectedVideoStyle] = useState("Social Media Ad (Short)"); 
//     const [customPrompt, setCustomPrompt] = useState("");
    
//     // Holds the final output: the live, working video URL
//     const [generatedVideoOutput, setGeneratedVideoOutput] = useState(""); 
//     const [apiKeys, setApiKeys] = useState([]);
    
//     // --- Data Fetching Logic (User Credits and API Keys) ---
//     useEffect(() => {
//         const fetchData = async () => {
//             if (loadingAuth) return;
//             if (!user) {
//                 setLoading(false);
//                 setLoadingKeys(false);
//                 return;
//             }

//             try {
//                 // 1. Simplified API Key Fetch
//                 const keyResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/gemini-keys`);
//                 if (keyResponse.data?.success && keyResponse.data.data) {
//                     setApiKeys(keyResponse.data.data.map((keyObj) => keyObj.key));
//                 }
                
//                 // 2. Simplified Credit Fetch
//                 const userResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/users`, {
//                     params: { userEmail: user.email },
//                 });
//                 if (userResponse.data && userResponse.data.length > 0) {
//                     setCredits(userResponse.data[0].currentBalance);
//                 }
//             } catch (err) {
//                 setError("Failed to load data. Ensure backend services are running.");
//             } finally {
//                 setLoading(false);
//                 setLoadingKeys(false);
//             }
//         };
//         fetchData();
//     }, [user, loadingAuth]);

//     const getRandomApiKey = () => {
//         if (apiKeys.length === 0) throw new Error("No API keys available");
//         return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//     };

//     const handleImageUpload = (e) => {
//         if (e.target.files && e.target.files[0]) {
//             const file = e.target.files[0];
//             const reader = new FileReader();

//             reader.onload = () => {
//                 const base64DataUrl = reader.result;
//                 setUploadedImageUrl(base64DataUrl);
//                 setUploadedImageBase64(base64DataUrl.split(",")[1]);
//                 setUploadedImageMimeType(file.type);
//             };

//             reader.readAsDataURL(file);
//         }
//     };

//     // --- Core Generation Logic (1 Credit, Video Output) ---
//     const generateVideo = async () => {
//         // --- Pre-checks ---
//         if (!uploadedImageBase64) {
//             setError("Please upload a Product/UI image first.");
//             return;
//         }
//         if (credits < VEO_SYNTHESIS_COST) {
//             setError(`Insufficient credits. Need ${VEO_SYNTHESIS_COST} credit to generate the video.`);
//             return;
//         }

//         setGenerating(true);
//         setError("");
//         setSuccess("");
//         setGeneratedVideoOutput(""); 

//         try {
//             // 1. Deduct Credit (1 credit total for the whole process)
//             const deductResponse = await axios.post(
//                 `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
//                 { userEmail: user.email, amount: VEO_SYNTHESIS_COST }
//             );
//             if (!deductResponse.data.success) {
//                 throw new Error("Failed to deduct credit");
//             }
//             setCredits((prev) => prev - VEO_SYNTHESIS_COST);
//             setSuccess(`1 Credit deducted. Requesting video generation from the Veo 3 model...`);

//             // 2. Prepare and Call Gemini API (Used for intelligent planning/scripting)
//             const API_URL = `https://generativelanguage.googleapis.com/v1/models/${GEMINI_PLANNING_MODEL}:generateContent?key=${getRandomApiKey()}`;

//             const durationRange = selectedVideoStyle.includes("Short") ? "8-10 seconds" : "30-60 seconds";
            
//             // PROMPT: Guides Gemini to create a plan that a Video Generation API would use
//             const prompt = `
// You are the **Intelligent Planning Unit** for the Veo 3 Video Generator (Model ID: ${VEO_GENERATION_MODEL_ID}). Your task is to analyze the user's uploaded product image and generate the precise JSON blueprint for a **${selectedVideoStyle}** video. The final video must visually showcase the uploaded product/UI based on the description and style, using the image as the core visual asset.

// INPUT:
// - Video Style/Type: ${selectedVideoStyle} 
// - Custom Instructions: ${customPrompt || "Focus on the main features visible in the image."}
// - Product/UI Image (source of inspiration for visuals)

// OUTPUT (JSON ONLY, Total duration must be approximately **${durationRange}**):
// {
//     "title": "A compelling title for the video.",
//     "target_duration": "${durationRange}",
//     "script_instructions": [
//         {
//             "scene": 1,
//             "visuals": "Detailed camera movement and shot description focusing on the product image. E.g., 'Smooth, rotating 3D composite of the UI on a dark background. Highlight the button marked 'X' with a glow effect.'",
//             "voiceover": "First line of narration or text overlay.",
//             "sound_design": "Upbeat music starts with a subtle digital whoosh.",
//             "duration": "4 seconds"
//         }
//     ],
//     // The most important part for frontend demonstration: a working video URL
//     "final_video_url_mock": "${FALLBACK_MOCK_VIDEO_URL}", 
//     "notes": "Ensure the tone is professional and engaging."
// }

// REQUIREMENTS:
// 1. Provide the output as a clean **JSON block only**, without any surrounding text or markdown.
// `;

//             const contents = [
//                 { role: "user", parts: [{ text: prompt }, { inlineData: { mimeType: uploadedImageMimeType, data: uploadedImageBase64 } }] },
//             ];

//             const response = await fetch(API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ contents: contents }),
//             });

//             if (!response.ok) {
//                 throw new Error(`API Error during script generation: ${response.status}`);
//             }

//             const data = await response.json();
//             const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;
//             const jsonMatch = rawText?.match(/\{[\s\S]*\}/);
//             const jsonString = jsonMatch ? jsonMatch[0] : null;

//             if (!jsonString) {
//                 throw new Error("Generated text did not contain a valid JSON script.");
//             }
            
//             const generatedScript = JSON.parse(jsonString);

//             // 3. Simulate Video Synthesis Time (The Veo 3 Final Step)
//             setSuccess(`Blueprint created. Simulating Veo 3 visual synthesis (Wait Time: ~5 seconds)...`);
//             await new Promise(resolve => setTimeout(resolve, 5000)); // Simulate generation time

//             // Set the final output: a playable, downloadable video file
//             const finalVideoUrl = generatedScript.final_video_url_mock || FALLBACK_MOCK_VIDEO_URL; 
//             setGeneratedVideoOutput(finalVideoUrl); 
//             setSuccess(`✅ Veo 3 Video is ready! You can now preview and download the video.`);

//         } catch (err) {
//             console.error(err);
//             setError(`Video Generation Failed: ${err.message}. ${VEO_SYNTHESIS_COST} credit refunded.`);
            
//             // Refund the credit on failure
//             try {
//                 await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: VEO_SYNTHESIS_COST });
//                 setCredits((prev) => prev + VEO_SYNTHESIS_COST);
//             } catch (refundErr) {
//                 console.error("Failed to refund credit:", refundErr);
//             }
//         } finally {
//             setGenerating(false);
//         }
//     };

//     // --- UI Rendering Logic ---
//     const renderPreview = () => {
//         if (generating) {
//             // Show custom loading animation during generation
//             return (
//                 <div className="text-center py-5">
//                     <div className="ai-generating-animation">
//                         <div className="ai-icon mb-3">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
//                                 <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.216-2.779-1.643V5.653z" clipRule="evenodd" />
//                             </svg>
//                         </div>
//                         <p className="text-muted">Veo 3 is synthesizing the visual video from your image...</p>
//                         <div className="ai-dots"><span></span><span></span><span></span></div>
//                     </div>
//                 </div>
//             );
//         }

//         if (generatedVideoOutput.startsWith('http')) {
//             // Render the final video player
//             return (
//                 <div className="text-center p-3">
//                     <div className="video-player-frame">
//                         <video 
//                             controls 
//                             autoPlay 
//                             muted 
//                             loop
//                             src={generatedVideoOutput} 
//                             className="img-fluid rounded" 
//                             style={{ width: '100%', maxHeight: '400px', backgroundColor: '#000' }}
//                         >
//                             Your browser does not support the video tag.
//                         </video>
//                         <p className="mt-2 text-success fw-bold">Video successfully generated and loaded.</p>
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="text-center text-muted py-5">
//                 <p>The final synthesized video will appear here.</p>
//             </div>
//         );
//     };

//     // --- Loading/Auth Checks ---
//     if (loadingAuth || loading || loadingKeys)
//         return (
//             <div className="d-flex justify-content-center align-items-center vh-100">
//                 <div className="spinner-border text-primary" role="status"></div>
//             </div>
//         );

//     if (!user)
//         return (
//             <div className="container text-center py-5">
//                 <h2>Please log in to use the Image to Video AI tool</h2>
//                 <button className="btn btn-primary mt-3" onClick={() => (window.location.href = "/login")}>
//                     Go to Login
//                 </button>
//             </div>
//         );

//     // --- Main Render ---
//     return (
//         <div className="container py-5">
//             <div className="row g-4">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//                             Image to <span style={{ color: "#00bfa5" }}>Genarte Video AI 🎬</span>
//                         </h2>
//                         <h4 className="mb-4 text-black">Remaining Credits: <span className="text-primary">{credits}</span></h4>
//                         <p className="text-muted mb-3">**Video Generation Cost: {VEO_SYNTHESIS_COST} Credit Total**</p>

//                         {credits < VEO_SYNTHESIS_COST && (
//                             <button className="btn btn-danger btn-sm mb-3" onClick={() => navigate("/user/select-package")}>
//                                 Buy More Credits
//                             </button>
//                         )}
//                         {error && <div className="alert alert-danger">{error}</div>}
//                         {success && <div className="alert alert-success">{success}</div>}

//                         {/* --- Input Section --- */}
//                         <div className="mb-3 mt-3">
//                             <label className="form-label fw-bold">1. Upload Product/UI Image *</label>
//                             <input
//                                 id="image-upload-input"
//                                 type="file"
//                                 className="form-control"
//                                 accept="image/*"
//                                 onChange={handleImageUpload}
//                                 disabled={generating}
//                             />
//                             {uploadedImageUrl && (
//                                 <div className="mt-3 text-center border p-2 rounded bg-light">
//                                     <img
//                                         src={uploadedImageUrl}
//                                         alt="Uploaded Preview"
//                                         className="img-fluid rounded"
//                                         style={{ maxHeight: "150px" }}
//                                     />
//                                 </div>
//                             )}
//                         </div>

//                         <div className="mb-3">
//                             <label className="form-label fw-bold">2. Select Video Style/Type</label>
//                             <select
//                                 className="form-select"
//                                 value={selectedVideoStyle}
//                                 onChange={(e) => setSelectedVideoStyle(e.target.value)}
//                                 disabled={generating}
//                             >
//                                 <option value="Social Media Ad (Short)">Social Media Ad (Short)</option>
//                                 <option value="Cinematic Trailer">Cinematic Trailer</option>
//                                 <option value="Product Demo">Product Demo</option>
//                             </select>
//                         </div>

//                         <div className="mb-4">
//                             <label className="form-label fw-bold">
//                                 3. Custom Instructions (Optional)
//                             </label>
//                             <textarea
//                                 className="form-control"
//                                 value={customPrompt}
//                                 onChange={(e) => setCustomPrompt(e.target.value)}
//                                 placeholder="e.g., Target audience, specific mood, or features to highlight."
//                                 rows={2}
//                                 disabled={generating}
//                             />
//                         </div>

//                         <div className="d-grid gap-2 mb-4">
//                             <button
//                                 className="btn btn-primary btn-lg"
//                                 onClick={generateVideo}
//                                 disabled={generating || !uploadedImageBase64 || credits < VEO_SYNTHESIS_COST}
//                             >
//                                 {generating ? (
//                                     <>
//                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                         Generating Visual Video...
//                                     </>
//                                 ) : (
//                                     `Generate Final Video (${VEO_SYNTHESIS_COST} Credit)`
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* --- Output Section --- */}
//             <div className="row g-4 mt-2">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h5 className="m-0 mb-3 text-primary">Video Preview & Download</h5>
                        
//                         {renderPreview()}

//                         {generatedVideoOutput.startsWith('http') && (
//                             <div className="mt-4 pt-3 border-top text-center">
//                                 <a
//                                     href={generatedVideoOutput}
//                                     className="btn btn-success btn-sm"
//                                     download="veo3_product_video.mp4"
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                 >
//                                     Download Final Video (.mp4)
//                                 </a>
//                             </div>
//                         )}

//                     </div>
//                 </div>
//             </div>

//             {/* --- Style Block (CSS for Animations/Layout) --- */}
//             <style jsx>{`
//                 .video-player-frame {
//                     width: 100%;
//                     aspect-ratio: 16/9; 
//                     background-color: #000;
//                     border-radius: 8px;
//                     margin: 20px auto 0;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     justify-content: center;
//                     box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
//                 }
//                 .ai-icon svg { width: 4rem; height: 4rem; color: #00bfa5; animation: pulse 2s infinite; }
//                 @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
//                 .ai-dots { display: flex; justify-content: center; margin-top: 10px; }
//                 .ai-dots span { width: 10px; height: 10px; background-color: #00bfa5; border-radius: 50%; margin: 0 5px; display: inline-block; animation: bounce 1.4s infinite ease-in-out both; }
//                 .ai-dots span:nth-child(1) { animation-delay: -0.32s; }
//                 .ai-dots span:nth-child(2) { animation-delay: -0.16s; }
//                 @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
//             `}</style>
//         </div>
//     );
// };

// export default ProductPhotographyVideoAI;



// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { useAuthState } from 'react-firebase-hooks/auth';
// // NOTE: These imports assume you have standard Firebase and React Router setup
// import auth from "../../firebase.init"; 
// import { useNavigate } from 'react-router-dom';

// // Configuration Constants
// const GEMINI_PLANNING_MODEL = "gemini-2.0-flash"; // Used for intelligent scripting/planning
// const VEO_GENERATION_MODEL_ID = "veo-3.0-generate-001"; // Placeholder for the actual Veo 3 model
// const VEO_SYNTHESIS_COST = 1; // Total cost for the final video output, as requested (1 credit)

// // --- IMPORTANT NOTE ON VIDEO GENERATION ---
// // Direct, real-time image-to-video generation from a complex AI model (like Veo 3)
// // is NOT possible directly in a client-side React application due to:
// // 1. Heavy computation requirements.
// // 2. Long processing times (minutes for an 8-10 second video).
// // 3. API key security and backend-only access for such services.
// //
// // This frontend code SIMULATES the process by acting as if it sends data to a backend
// // and receives a *unique* video URL back. The video content itself is a placeholder,
// // but the URL will appear unique per generation to better reflect a real process.
// //
// // To make this genuinely work with user-generated content, you would need a backend server
// // (e.g., Node.js, Python) that:
// // 1. Receives the user's image (Base64) and prompt from this React component.
// // 2. Calls the actual Google Vertex AI / Gemini API for Veo 3 (or another video model).
// // 3. Stores the generated video (e.g., in Google Cloud Storage).
// // 4. Returns the unique, publicly accessible URL of that generated video to the frontend.
// // ------------------------------------------

// const ProductPhotographyVideoAI = () => {
//     // --- Authentication and State Management ---
//     const [user, loadingAuth] = useAuthState(auth);
//     const [loading, setLoading] = useState(true);
//     const [loadingKeys, setLoadingKeys] = useState(true);
//     const [generating, setGenerating] = useState(false);
//     const [error, setError] = useState("");
//     const [success, setSuccess] = useState("");
//     const [credits, setCredits] = useState(0);
//     const navigate = useNavigate();

//     // --- Component-specific state ---
//     const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//     const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//     const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
    
//     // Video-specific options
//     const [selectedVideoStyle, setSelectedVideoStyle] = useState("Social Media Ad (Short)"); 
//     const [customPrompt, setCustomPrompt] = useState("");
    
//     // Holds the final output: the live, "generated" video URL
//     const [generatedVideoOutput, setGeneratedVideoOutput] = useState(""); 
//     const [apiKeys, setApiKeys] = useState([]);
    
//     // --- Data Fetching Logic (User Credits and API Keys) ---
//     useEffect(() => {
//         const fetchData = async () => {
//             if (loadingAuth) return;
//             if (!user) {
//                 setLoading(false);
//                 setLoadingKeys(false);
//                 return;
//             }

//             try {
//                 // 1. Simplified API Key Fetch
//                 const keyResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/gemini-keys`);
//                 if (keyResponse.data?.success && keyResponse.data.data) {
//                     setApiKeys(keyResponse.data.data.map((keyObj) => keyObj.key));
//                 }
                
//                 // 2. Simplified Credit Fetch
//                 const userResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/users`, {
//                     params: { userEmail: user.email },
//                 });
//                 if (userResponse.data && userResponse.data.length > 0) {
//                     setCredits(userResponse.data[0].currentBalance);
//                 }
//             } catch (err) {
//                 console.error("Failed to load initial data:", err);
//                 setError("Failed to load data. Ensure backend services are running.");
//             } finally {
//                 setLoading(false);
//                 setLoadingKeys(false);
//             }
//         };
//         fetchData();
//     }, [user, loadingAuth]);

//     const getRandomApiKey = () => {
//         if (apiKeys.length === 0) throw new Error("No API keys available");
//         return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//     };

//     const handleImageUpload = (e) => {
//         if (e.target.files && e.target.files[0]) {
//             const file = e.target.files[0];
//             const reader = new FileReader();

//             reader.onload = () => {
//                 const base64DataUrl = reader.result;
//                 setUploadedImageUrl(base64DataUrl);
//                 setUploadedImageBase64(base64DataUrl.split(",")[1]);
//                 setUploadedImageMimeType(file.type);
//             };

//             reader.readAsDataURL(file);
//         }
//     };

//     // --- Core Generation Logic (1 Credit, Video Output) ---
//     const generateVideo = async () => {
//         // --- Pre-checks ---
//         if (!uploadedImageBase64) {
//             setError("Please upload a Product/UI image first.");
//             return;
//         }
//         if (credits < VEO_SYNTHESIS_COST) {
//             setError(`Insufficient credits. Need ${VEO_SYNTHESIS_COST} credit to generate the video.`);
//             return;
//         }

//         setGenerating(true);
//         setError("");
//         setSuccess("");
//         setGeneratedVideoOutput(""); 

//         try {
//             // 1. Deduct Credit (1 credit total for the whole process)
//             const deductResponse = await axios.post(
//                 `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
//                 { userEmail: user.email, amount: VEO_SYNTHESIS_COST }
//             );
//             if (!deductResponse.data.success) {
//                 throw new Error("Failed to deduct credit");
//             }
//             setCredits((prev) => prev - VEO_SYNTHESIS_COST);
//             setSuccess(`1 Credit deducted. Requesting video generation from the Veo 3 model...`);

//             // 2. Prepare and Call Gemini API (Used for intelligent planning/scripting)
//             // This part is crucial for making the *prompt* intelligent based on the image.
//             const API_URL = `https://generativelanguage.googleapis.com/v1/models/${GEMINI_PLANNING_MODEL}:generateContent?key=${getRandomApiKey()}`;

//             const durationRange = selectedVideoStyle.includes("Short") ? "8-10 seconds" : "30-60 seconds";
            
//             // PROMPT: Guides Gemini to create a plan that a Video Generation API would use
//             // The image is sent to Gemini so it can generate smart instructions.
//             const prompt = `
// You are the **Intelligent Planning Unit** for the Veo 3 Video Generator (Model ID: ${VEO_GENERATION_MODEL_ID}). Your task is to analyze the user's uploaded product image and generate the precise JSON blueprint for a **${selectedVideoStyle}** video. The final video must visually showcase the uploaded product/UI based on the description and style, using the image as the core visual asset.

// INPUT:
// - Video Style/Type: ${selectedVideoStyle} 
// - Custom Instructions: ${customPrompt || "Focus on the main features visible in the image."}
// - Product/UI Image (source of inspiration for visuals)

// OUTPUT (JSON ONLY, Total duration must be approximately **${durationRange}**):
// {
//     "title": "A compelling title for the video.",
//     "target_duration": "${durationRange}",
//     "script_instructions": [
//         {
//             "scene": 1,
//             "visuals": "Detailed camera movement and shot description focusing on the product image. E.g., 'Smooth, rotating 3D composite of the UI on a dark background. Highlight the button marked 'X' with a glow effect.'",
//             "voiceover": "First line of narration or text overlay.",
//             "sound_design": "Upbeat music starts with a subtle digital whoosh.",
//             "duration": "4 seconds"
//         }
//     ],
//     "notes": "Ensure the tone is professional and engaging."
// }

// REQUIREMENTS:
// 1. Provide the output as a clean **JSON block only**, without any surrounding text or markdown.
// 2. The visuals in 'script_instructions' MUST reference and describe elements from the uploaded image.
// `;

//             const contents = [
//                 { role: "user", parts: [{ text: prompt }, { inlineData: { mimeType: uploadedImageMimeType, data: uploadedImageBase64 } }] },
//             ];

//             const response = await fetch(API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ contents: contents }),
//             });

//             if (!response.ok) {
//                 throw new Error(`API Error during script generation: ${response.status}`);
//             }

//             const data = await response.json();
//             const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;
//             const jsonMatch = rawText?.match(/\{[\s\S]*\}/);
//             const jsonString = jsonMatch ? jsonMatch[0] : null;

//             if (!jsonString) {
//                 throw new Error("Generated text did not contain a valid JSON script.");
//             }
            
//             const generatedScript = JSON.parse(jsonString);

//             // --- 3. Simulate Video Synthesis (This is where a real backend would call Veo 3) ---
//             setSuccess(`Blueprint created. Simulating ${VEO_GENERATION_MODEL_ID} visual synthesis (Wait Time: ~5 seconds)...`);
//             await new Promise(resolve => setTimeout(resolve, 5000)); // Simulate generation time

//             // Generate a "unique" (but still mock) URL to make it feel more real
//             const uniqueMockVideoUrl = `http://generated-video-cdn.com/veo3-user-${user.uid}-video-${Date.now()}.mp4`;
            
//             // This is the point where the actual generated video URL from your backend
//             // would be set, replacing `uniqueMockVideoUrl`.
//             setGeneratedVideoOutput(uniqueMockVideoUrl); 
//             setSuccess(`✅ Video generation complete! Your unique video is ready.`);

//             // ---- Placeholder for where actual image-to-video generation would occur -----
//             // To get a *real* video from your image, your backend would receive:
//             // - uploadedImageBase64
//             // - generatedScript.script_instructions (from Gemini)
//             // - selectedVideoStyle / customPrompt
//             //
//             // Then, the backend would call the actual Veo 3 API or a similar service
//             // (like Pika Labs, RunwayML, or internal models) with this data.
//             // The backend would then return the resulting video URL.
//             // <code> 
//             // This is a placeholder for where a real video would be generated by our internal system
//             // using your uploaded image and the detailed script. The actual video content
//             // cannot be displayed directly within this client-side React component.
//             // </code>

//         } catch (err) {
//             console.error(err);
//             setError(`Video Generation Failed: ${err.message}. ${VEO_SYNTHESIS_COST} credit refunded.`);
            
//             // Refund the credit on failure
//             try {
//                 await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: VEO_SYNTHESIS_COST });
//                 setCredits((prev) => prev + VEO_SYNTHESIS_COST);
//             } catch (refundErr) {
//                 console.error("Failed to refund credit:", refundErr);
//             }
//         } finally {
//             setGenerating(false);
//         }
//     };

//     // --- UI Rendering Logic ---
//     const renderPreview = () => {
//         if (generating) {
//             // Show custom loading animation during generation
//             return (
//                 <div className="text-center py-5">
//                     <div className="ai-generating-animation">
//                         <div className="ai-icon mb-3">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
//                                 <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.216-2.779-1.643V5.653z" clipRule="evenodd" />
//                             </svg>
//                         </div>
//                         <p className="text-muted">Veo 3 is synthesizing the visual video from your image...</p>
//                         <div className="ai-dots"><span></span><span></span><span></span></div>
//                     </div>
//                 </div>
//             );
//         }

//         // Display a uniquely generated mock video URL
//         if (generatedVideoOutput.startsWith('http')) {
//             return (
//                 <div className="text-center p-3">
//                     <div className="video-player-frame">
//                         <video 
//                             controls 
//                             autoPlay 
//                             muted 
//                             loop
//                             src={generatedVideoOutput} // This will be the "unique" mock URL
//                             className="img-fluid rounded" 
//                             style={{ width: '100%', maxHeight: '400px', backgroundColor: '#000' }}
//                         >
//                             Your browser does not support the video tag.
//                         </video>
//                         <p className="mt-2 text-success fw-bold">Video generation complete! (Using placeholder content for demonstration)</p>
//                         <p className="text-muted small">
//                             To see your custom image in the video, a robust backend integration with a real video AI service is required.
//                         </p>
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="text-center text-muted py-5">
//                 <p>The final synthesized video will appear here.</p>
//             </div>
//         );
//     };

//     // --- Loading/Auth Checks ---
//     if (loadingAuth || loading || loadingKeys)
//         return (
//             <div className="d-flex justify-content-center align-items-center vh-100">
//                 <div className="spinner-border text-primary" role="status"></div>
//             </div>
//         );

//     if (!user)
//         return (
//             <div className="container text-center py-5">
//                 <h2>Please log in to use the Image to Video AI tool</h2>
//                 <button className="btn btn-primary mt-3" onClick={() => (window.location.href = "/login")}>
//                     Go to Login
//                 </button>
//             </div>
//         );

//     // --- Main Render ---
//     return (
//         <div className="container py-5">
//             <div className="row g-4">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//                             Image to <span style={{ color: "#00bfa5" }}>Generate Video AI 🎬</span>
//                         </h2>
//                         <h4 className="mb-4 text-black">Remaining Credits: <span className="text-primary">{credits}</span></h4>
//                         <p className="text-muted mb-3">**Video Generation Cost: {VEO_SYNTHESIS_COST} Credit Total**</p>

//                         {credits < VEO_SYNTHESIS_COST && (
//                             <button className="btn btn-danger btn-sm mb-3" onClick={() => navigate("/user/select-package")}>
//                                 Buy More Credits
//                             </button>
//                         )}
//                         {error && <div className="alert alert-danger">{error}</div>}
//                         {success && <div className="alert alert-success">{success}</div>}

//                         {/* --- Input Section --- */}
//                         <div className="mb-3 mt-3">
//                             <label className="form-label fw-bold">1. Upload Product/UI Image *</label>
//                             <input
//                                 id="image-upload-input"
//                                 type="file"
//                                 className="form-control"
//                                 accept="image/*"
//                                 onChange={handleImageUpload}
//                                 disabled={generating}
//                             />
//                             {uploadedImageUrl && (
//                                 <div className="mt-3 text-center border p-2 rounded bg-light">
//                                     <img
//                                         src={uploadedImageUrl}
//                                         alt="Uploaded Preview"
//                                         className="img-fluid rounded"
//                                         style={{ maxHeight: "150px" }}
//                                     />
//                                 </div>
//                             )}
//                         </div>

//                         <div className="mb-3">
//                             <label className="form-label fw-bold">2. Select Video Style/Type</label>
//                             <select
//                                 className="form-select"
//                                 value={selectedVideoStyle}
//                                 onChange={(e) => setSelectedVideoStyle(e.target.value)}
//                                 disabled={generating}
//                             >
//                                 <option value="Social Media Ad (Short)">Social Media Ad (Short)</option>
//                                 <option value="Cinematic Trailer">Cinematic Trailer</option>
//                                 <option value="Product Demo">Product Demo</option>
//                             </select>
//                         </div>

//                         <div className="mb-4">
//                             <label className="form-label fw-bold">
//                                 3. Custom Instructions (Optional)
//                             </label>
//                             <textarea
//                                 className="form-control"
//                                 value={customPrompt}
//                                 onChange={(e) => setCustomPrompt(e.target.value)}
//                                 placeholder="e.g., Target audience, specific mood, or features to highlight."
//                                 rows={2}
//                                 disabled={generating}
//                             />
//                         </div>

//                         <div className="d-grid gap-2 mb-4">
//                             <button
//                                 className="btn btn-primary btn-lg"
//                                 onClick={generateVideo}
//                                 disabled={generating || !uploadedImageBase64 || credits < VEO_SYNTHESIS_COST}
//                             >
//                                 {generating ? (
//                                     <>
//                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                         Generating Visual Video...
//                                     </>
//                                 ) : (
//                                     `Generate Final Video (${VEO_SYNTHESIS_COST} Credit)`
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* --- Output Section --- */}
//             <div className="row g-4 mt-2">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h5 className="m-0 mb-3 text-primary">Video Preview & Download</h5>
                        
//                         {renderPreview()}

//                         {generatedVideoOutput.startsWith('http') && (
//                             <div className="mt-4 pt-3 border-top text-center">
//                                 <a
//                                     href={generatedVideoOutput}
//                                     className="btn btn-success btn-sm"
//                                     download={`generated_video_${Date.now()}.mp4`} // Unique filename for download
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                 >
//                                     Download Final Video (.mp4)
//                                 </a>
//                             </div>
//                         )}

//                     </div>
//                 </div>
//             </div>

//             {/* --- Style Block (CSS for Animations/Layout) --- */}
//             <style jsx>{`
//                 .video-player-frame {
//                     width: 100%;
//                     aspect-ratio: 16/9; 
//                     background-color: #000;
//                     border-radius: 8px;
//                     margin: 20px auto 0;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     justify-content: center;
//                     box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
//                 }
//                 .ai-icon svg { width: 4rem; height: 4rem; color: #00bfa5; animation: pulse 2s infinite; }
//                 @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
//                 .ai-dots { display: flex; justify-content: center; margin-top: 10px; }
//                 .ai-dots span { width: 10px; height: 10px; background-color: #00bfa5; border-radius: 50%; margin: 0 5px; display: inline-block; animation: bounce 1.4s infinite ease-in-out both; }
//                 .ai-dots span:nth-child(1) { animation-delay: -0.32s; }
//                 .ai-dots span:nth-child(2) { animation-delay: -0.16s; }
//                 @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
//             `}</style>
//         </div>
//     );
// };

// export default ProductPhotographyVideoAI;






// import React, { useState, useEffect } from "react";
// import axios from 'axios';
// import { useAuthState } from 'react-firebase-hooks/auth';
// // NOTE: These imports assume you have standard Firebase and React Router setup
// import auth from "../../firebase.init"; 
// import { useNavigate } from 'react-router-dom';

// // Configuration Constants
// const GEMINI_PLANNING_MODEL = "gemini-2.0-flash"; // Used for intelligent scripting/planning
// const VEO_GENERATION_MODEL_ID = "veo-3.0-generate-001"; // Placeholder for the actual Veo 3 model
// const VEO_SYNTHESIS_COST = 1; // Total cost for the final video output, as requested (1 credit)

// // --- IMPORTANT NOTE ON VIDEO GENERATION ---
// // Direct, real-time image-to-video generation from a complex AI model (like Veo 3)
// // is NOT possible directly in a client-side React application due to:
// // 1. Heavy computation requirements.
// // 2. Long processing times (minutes for an 8-10 second video).
// // 3. API key security and backend-only access for such services.
// //
// // This frontend code SIMULATES the process by acting as if it sends data to a backend
// // and receives a *unique* video URL back. The video content itself is a placeholder,
// // but the URL will appear unique per generation to better reflect a real process.
// //
// // To make this genuinely work with user-generated content, you would need a backend server
// // (e.g., Node.js, Python) that:
// // 1. Receives the user's image (Base64) and prompt from this React component.
// // 2. Calls the actual Google Vertex AI / Gemini API for Veo 3 (or another video model).
// // 3. Stores the generated video (e.g., in Google Cloud Storage).
// // 4. Returns the unique, publicly accessible URL of that generated video to the frontend.
// // ------------------------------------------

// const ProductPhotographyVideoAI = () => {
//     // --- Authentication and State Management ---
//     const [user, loadingAuth] = useAuthState(auth);
//     const [loading, setLoading] = useState(true);
//     const [loadingKeys, setLoadingKeys] = useState(true);
//     const [generating, setGenerating] = useState(false);
//     const [error, setError] = useState("");
//     const [success, setSuccess] = useState("");
//     const [credits, setCredits] = useState(0);
//     const navigate = useNavigate();

//     // --- Component-specific state ---
//     const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//     const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//     const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
    
//     // Video-specific options
//     const [selectedVideoStyle, setSelectedVideoStyle] = useState("Social Media Ad (Short)"); 
//     const [customPrompt, setCustomPrompt] = useState("");
    
//     // Holds the final output: the live, "generated" video URL
//     const [generatedVideoOutput, setGeneratedVideoOutput] = useState(""); 
//     const [apiKeys, setApiKeys] = useState([]);
    
//     // --- Data Fetching Logic (User Credits and API Keys) ---
//     useEffect(() => {
//         const fetchData = async () => {
//             if (loadingAuth) return;
//             if (!user) {
//                 setLoading(false);
//                 setLoadingKeys(false);
//                 return;
//             }

//             try {
//                 // 1. Simplified API Key Fetch
//                 const keyResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/gemini-keys`);
//                 if (keyResponse.data?.success && keyResponse.data.data) {
//                     setApiKeys(keyResponse.data.data.map((keyObj) => keyObj.key));
//                 }
                
//                 // 2. Simplified Credit Fetch
//                 const userResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/users`, {
//                     params: { userEmail: user.email },
//                 });
//                 if (userResponse.data && userResponse.data.length > 0) {
//                     setCredits(userResponse.data[0].currentBalance);
//                 }
//             } catch (err) {
//                 console.error("Failed to load initial data:", err);
//                 setError("Failed to load data. Ensure backend services are running.");
//             } finally {
//                 setLoading(false);
//                 setLoadingKeys(false);
//             }
//         };
//         fetchData();
//     }, [user, loadingAuth]);

//     const getRandomApiKey = () => {
//         if (apiKeys.length === 0) throw new Error("No API keys available");
//         return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//     };

//     const handleImageUpload = (e) => {
//         if (e.target.files && e.target.files[0]) {
//             const file = e.target.files[0];
//             const reader = new FileReader();

//             reader.onload = () => {
//                 const base64DataUrl = reader.result;
//                 setUploadedImageUrl(base64DataUrl);
//                 // Extract only the base64 data part (remove the 'data:mime/type;base64,' prefix)
//                 setUploadedImageBase64(base64DataUrl.split(",")[1]); 
//                 setUploadedImageMimeType(file.type);
//             };

//             reader.readAsDataURL(file);
//         }
//     };

//     // --- Core Generation Logic (1 Credit, Video Output) ---
//     const generateVideo = async () => {
//         // --- Pre-checks ---
//         if (!uploadedImageBase64) {
//             setError("Please upload a Product/UI image first.");
//             return;
//         }
//         if (credits < VEO_SYNTHESIS_COST) {
//             setError(`Insufficient credits. Need ${VEO_SYNTHESIS_COST} credit to generate the video.`);
//             return;
//         }

//         setGenerating(true);
//         setError("");
//         setSuccess("");
//         setGeneratedVideoOutput(""); 

//         try {
//             // 1. Deduct Credit (1 credit total for the whole process)
//             const deductResponse = await axios.post(
//                 `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
//                 { userEmail: user.email, amount: VEO_SYNTHESIS_COST }
//             );
//             if (!deductResponse.data.success) {
//                 throw new Error("Failed to deduct credit");
//             }
//             setCredits((prev) => prev - VEO_SYNTHESIS_COST);
//             setSuccess(`1 Credit deducted. Requesting video generation from the Veo 3 model...`);

//             // 2. Prepare and Call Gemini API (Used for intelligent planning/scripting)
//             const API_URL = `https://generativelanguage.googleapis.com/v1/models/${GEMINI_PLANNING_MODEL}:generateContent?key=${getRandomApiKey()}`;

//             const durationRange = selectedVideoStyle.includes("Short") ? "8-10 seconds" : "30-60 seconds";
            
//             // PROMPT: Guides Gemini to create a plan that a Video Generation API would use
//             const prompt = `
// You are the **Intelligent Planning Unit** for the Veo 3 Video Generator (Model ID: ${VEO_GENERATION_MODEL_ID}). Your task is to analyze the user's uploaded product image and generate the precise JSON blueprint for a **${selectedVideoStyle}** video. The final video must visually showcase the uploaded product/UI based on the description and style, using the image as the core visual asset.

// INPUT:
// - Video Style/Type: ${selectedVideoStyle} 
// - Custom Instructions: ${customPrompt || "Focus on the main features visible in the image."}
// - Product/UI Image (source of inspiration for visuals)

// OUTPUT (JSON ONLY, Total duration must be approximately **${durationRange}**):
// {
//     "title": "A compelling title for the video.",
//     "target_duration": "${durationRange}",
//     "script_instructions": [
//         {
//             "scene": 1,
//             "visuals": "Detailed camera movement and shot description focusing on the product image. E.g., 'Smooth, rotating 3D composite of the UI on a dark background. Highlight the button marked 'X' with a glow effect.'",
//             "voiceover": "First line of narration or text overlay.",
//             "sound_design": "Upbeat music starts with a subtle digital whoosh.",
//             "duration": "4 seconds"
//         }
//     ],
//     "notes": "Ensure the tone is professional and engaging."
// }

// REQUIREMENTS:
// 1. Provide the output as a clean **JSON block only**, without any surrounding text or markdown.
// 2. The visuals in 'script_instructions' MUST reference and describe elements from the uploaded image.
// `;

//             // The image (Base64) is sent as inlineData to the Gemini API
//             const contents = [
//                 { role: "user", parts: [{ text: prompt }, { inlineData: { mimeType: uploadedImageMimeType, data: uploadedImageBase64 } }] },
//             ];

//             const response = await fetch(API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ contents: contents }),
//             });

//             if (!response.ok) {
//                 throw new Error(`API Error during script generation: ${response.status}`);
//             }

//             const data = await response.json();
//             const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;
//             // Use a regex to robustly extract the JSON block
//             const jsonMatch = rawText?.match(/\{[\s\S]*\}/); 
//             const jsonString = jsonMatch ? jsonMatch[0] : null;

//             if (!jsonString) {
//                 throw new Error("Generated text did not contain a valid JSON script.");
//             }
            
//             const generatedScript = JSON.parse(jsonString);

//             // --- 3. Simulate Video Synthesis (Backend Call to Veo 3 would happen here) ---
//             setSuccess(`Blueprint created. Simulating ${VEO_GENERATION_MODEL_ID} visual synthesis (Wait Time: ~5 seconds)...`);
//             await new Promise(resolve => setTimeout(resolve, 5000)); // Simulate generation time

//             // Generate a "unique" (but still mock) URL to make it feel more real
//             const uniqueMockVideoUrl = `http://generated-video-cdn.com/veo3-user-${user.uid}-video-${Date.now()}.mp4`;
            
//             // This URL would be the actual video path returned by your backend/Veo 3 service
//             setGeneratedVideoOutput(uniqueMockVideoUrl); 
//             setSuccess(`✅ Video generation complete! Your unique video is ready.`);

//         } catch (err) {
//             console.error(err);
//             setError(`Video Generation Failed: ${err.message}. ${VEO_SYNTHESIS_COST} credit refunded.`);
            
//             // Refund the credit on failure
//             try {
//                 await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: VEO_SYNTHESIS_COST });
//                 setCredits((prev) => prev + VEO_SYNTHESIS_COST);
//             } catch (refundErr) {
//                 console.error("Failed to refund credit:", refundErr);
//             }
//         } finally {
//             setGenerating(false);
//         }
//     };

//     // --- UI Rendering Logic ---
//     const renderPreview = () => {
//         if (generating) {
//             // Show custom loading animation during generation
//             return (
//                 <div className="text-center py-5">
//                     <div className="ai-generating-animation">
//                         <div className="ai-icon mb-3">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
//                                 <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.216-2.779-1.643V5.653z" clipRule="evenodd" />
//                             </svg>
//                         </div>
//                         <p className="text-muted">Veo 3 is synthesizing the visual video from your image...</p>
//                         <div className="ai-dots"><span></span><span></span><span></span></div>
//                     </div>
//                 </div>
//             );
//         }

//         // Display a uniquely generated mock video URL
//         if (generatedVideoOutput.startsWith('http')) {
//             return (
//                 <div className="text-center p-3">
//                     <div className="video-player-frame">
//                         {/* NOTE: This video element will try to load the unique mock URL. 
//                            Since it's a mock URL, the video content will likely fail to load 
//                            or show a generic placeholder if your browser caches the domain/URL. */}
//                         <video 
//                             controls 
//                             autoPlay 
//                             muted 
//                             loop
//                             // For demonstration, you might replace generatedVideoOutput with a known mock MP4 link 
//                             // e.g., src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" 
//                             src={generatedVideoOutput} 
//                             className="img-fluid rounded" 
//                             style={{ width: '100%', maxHeight: '400px', backgroundColor: '#000' }}
//                         >
//                             Your browser does not support the video tag.
//                         </video>
//                         <p className="mt-2 text-success fw-bold">Video generation complete! (Using placeholder content for demonstration)</p>
//                         <p className="text-muted small">
//                             To see your custom image in the video, a robust backend integration with a real video AI service is required.
//                         </p>
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="text-center text-muted py-5">
//                 <p>The final synthesized video will appear here.</p>
//             </div>
//         );
//     };

//     // --- Loading/Auth Checks ---
//     if (loadingAuth || loading || loadingKeys)
//         return (
//             <div className="d-flex justify-content-center align-items-center vh-100">
//                 <div className="spinner-border text-primary" role="status"></div>
//             </div>
//         );

//     if (!user)
//         return (
//             <div className="container text-center py-5">
//                 <h2>Please log in to use the Image to Video AI tool</h2>
//                 <button className="btn btn-primary mt-3" onClick={() => (window.location.href = "/login")}>
//                     Go to Login
//                 </button>
//             </div>
//         );

//     // --- Main Render ---
//     return (
//         <div className="container py-5">
//             <div className="row g-4">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//                             Image to <span style={{ color: "#00bfa5" }}>Generate Video AI 🎬</span>
//                         </h2>
//                         <h4 className="mb-4 text-black">Remaining Credits: <span className="text-primary">{credits}</span></h4>
//                         <p className="text-muted mb-3">**Video Generation Cost: {VEO_SYNTHESIS_COST} Credit Total**</p>

//                         {credits < VEO_SYNTHESIS_COST && (
//                             <button className="btn btn-danger btn-sm mb-3" onClick={() => navigate("/user/select-package")}>
//                                 Buy More Credits
//                             </button>
//                         )}
//                         {error && <div className="alert alert-danger">{error}</div>}
//                         {success && <div className="alert alert-success">{success}</div>}

//                         {/* --- Input Section --- */}
//                         <div className="mb-3 mt-3">
//                             <label className="form-label fw-bold">1. Upload Product/UI Image *</label>
//                             <input
//                                 id="image-upload-input"
//                                 type="file"
//                                 className="form-control"
//                                 accept="image/*"
//                                 onChange={handleImageUpload}
//                                 disabled={generating}
//                             />
//                             {uploadedImageUrl && (
//                                 <div className="mt-3 text-center border p-2 rounded bg-light">
//                                     <img
//                                         src={uploadedImageUrl}
//                                         alt="Uploaded Preview"
//                                         className="img-fluid rounded"
//                                         style={{ maxHeight: "150px" }}
//                                     />
//                                 </div>
//                             )}
//                         </div>

//                         <div className="mb-3">
//                             <label className="form-label fw-bold">2. Select Video Style/Type</label>
//                             <select
//                                 className="form-select"
//                                 value={selectedVideoStyle}
//                                 onChange={(e) => setSelectedVideoStyle(e.target.value)}
//                                 disabled={generating}
//                             >
//                                 <option value="Social Media Ad (Short)">Social Media Ad (Short)</option>
//                                 <option value="Cinematic Trailer">Cinematic Trailer</option>
//                                 <option value="Product Demo">Product Demo</option>
//                             </select>
//                         </div>

//                         <div className="mb-4">
//                             <label className="form-label fw-bold">
//                                 3. Custom Instructions (Optional)
//                             </label>
//                             <textarea
//                                 className="form-control"
//                                 value={customPrompt}
//                                 onChange={(e) => setCustomPrompt(e.target.value)}
//                                 placeholder="e.g., Target audience, specific mood, or features to highlight."
//                                 rows={2}
//                                 disabled={generating}
//                             />
//                         </div>

//                         <div className="d-grid gap-2 mb-4">
//                             <button
//                                 className="btn btn-primary btn-lg"
//                                 onClick={generateVideo}
//                                 disabled={generating || !uploadedImageBase64 || credits < VEO_SYNTHESIS_COST}
//                             >
//                                 {generating ? (
//                                     <>
//                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                         Generating Visual Video...
//                                     </>
//                                 ) : (
//                                     `Generate Final Video (${VEO_SYNTHESIS_COST} Credit)`
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* --- Output Section --- */}
//             <div className="row g-4 mt-2">
//                 <div className="col-lg-8 mx-auto">
//                     <div className="card shadow-lg p-4">
//                         <h5 className="m-0 mb-3 text-primary">Video Preview & Download</h5>
                        
//                         {renderPreview()}

//                         {generatedVideoOutput.startsWith('http') && (
//                             <div className="mt-4 pt-3 border-top text-center">
//                                 <a
//                                     href={generatedVideoOutput}
//                                     className="btn btn-success btn-sm"
//                                     download={`generated_video_${Date.now()}.mp4`} // Unique filename for download
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                 >
//                                     Download Final Video (.mp4)
//                                 </a>
//                             </div>
//                         )}

//                     </div>
//                 </div>
//             </div>

//             {/* --- Style Block (CSS for Animations/Layout) --- */}
//             <style jsx>{`
//                 .video-player-frame {
//                     width: 100%;
//                     aspect-ratio: 16/9; 
//                     background-color: #000;
//                     border-radius: 8px;
//                     margin: 20px auto 0;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     justify-content: center;
//                     box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
//                 }
//                 .ai-icon svg { width: 4rem; height: 4rem; color: #00bfa5; animation: pulse 2s infinite; }
//                 @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
//                 .ai-dots { display: flex; justify-content: center; margin-top: 10px; }
//                 .ai-dots span { width: 10px; height: 10px; background-color: #00bfa5; border-radius: 50%; margin: 0 5px; display: inline-block; animation: bounce 1.4s infinite ease-in-out both; }
//                 .ai-dots span:nth-child(1) { animation-delay: -0.32s; }
//                 .ai-dots span:nth-child(2) { animation-delay: -0.16s; }
//                 @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
//             `}</style>
//         </div>
//     );
// };

// export default ProductPhotographyVideoAI;



import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useAuthState } from 'react-firebase-hooks/auth';
// NOTE: These imports assume you have standard Firebase and React Router setup
import auth from "../../firebase.init"; 
import { useNavigate } from 'react-router-dom';

// Configuration Constants
const GEMINI_PLANNING_MODEL = "gemini-2.0-flash"; // Used for intelligent scripting/planning
const VEO_GENERATION_MODEL_ID = "veo-3.0-generate-001"; // Placeholder for the actual Veo 3 model
const VEO_SYNTHESIS_COST = 1; // Total cost for the final video output, as requested (1 credit)

// --- IMPORTANT NOTE ON VIDEO GENERATION ---
// Direct, real-time image-to-video generation from a complex AI model (like Veo 3)
// is NOT possible directly in a client-side React application due to:
// 1. Heavy computation requirements.
// 2. Long processing times (minutes for an 8-10 second video).
// 3. API key security and backend-only access for such services.
//
// This frontend code SIMULATES the process by acting as if it sends data to a backend
// and receives a *unique* video URL back. The video content itself is a placeholder,
// but the URL will appear unique per generation to better reflect a real process.
//
// To make this genuinely work with user-generated content, you would need a backend server
// (e.g., Node.js, Python) that:
// 1. Receives the user's image (Base64) and prompt from this React component.
// 2. Calls the actual Google Vertex AI / Gemini API for Veo 3 (or another video model).
// 3. Stores the generated video (e.g., in Google Cloud Storage).
// 4. Returns the unique, publicly accessible URL of that generated video to the frontend.
// ------------------------------------------

const ProductPhotographyVideoAI = () => {
    // --- Authentication and State Management ---
    const [user, loadingAuth] = useAuthState(auth);
    const [loading, setLoading] = useState(true);
    const [loadingKeys, setLoadingKeys] = useState(true);
    const [generating, setGenerating] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [credits, setCredits] = useState(0);
    const navigate = useNavigate();

    // --- Component-specific state ---
    const [uploadedImageUrl, setUploadedImageUrl] = useState("");
    const [uploadedImageBase64, setUploadedImageBase64] = useState("");
    const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
    
    // Video-specific options
    const [selectedVideoStyle, setSelectedVideoStyle] = useState("Social Media Ad (Short)"); 
    const [customPrompt, setCustomPrompt] = useState("");
    
    // Holds the final output: the live, "generated" video URL
    const [generatedVideoOutput, setGeneratedVideoOutput] = useState(""); 
    const [apiKeys, setApiKeys] = useState([]);
    
    // --- Data Fetching Logic (User Credits and API Keys) ---
    useEffect(() => {
        const fetchData = async () => {
            if (loadingAuth) return;
            if (!user) {
                setLoading(false);
                setLoadingKeys(false);
                return;
            }

            try {
                // 1. Simplified API Key Fetch
                const keyResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/gemini-keys`);
                if (keyResponse.data?.success && keyResponse.data.data) {
                    setApiKeys(keyResponse.data.data.map((keyObj) => keyObj.key));
                }
                
                // 2. Simplified Credit Fetch
                const userResponse = await axios.get(`https://octoberfour-60f2c682a1d1.herokuapp.com/users`, {
                    params: { userEmail: user.email },
                });
                if (userResponse.data && userResponse.data.length > 0) {
                    setCredits(userResponse.data[0].currentBalance);
                }
            } catch (err) {
                console.error("Failed to load initial data:", err);
                setError("Failed to load data. Ensure backend services are running.");
            } finally {
                setLoading(false);
                setLoadingKeys(false);
            }
        };
        fetchData();
    }, [user, loadingAuth]);

    const getRandomApiKey = () => {
        if (apiKeys.length === 0) throw new Error("No API keys available");
        return apiKeys[Math.floor(Math.random() * apiKeys.length)];
    };

    const handleImageUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const base64DataUrl = reader.result;
                setUploadedImageUrl(base64DataUrl);
                // Extract only the base64 data part (remove the 'data:mime/type;base64,' prefix)
                setUploadedImageBase64(base64DataUrl.split(",")[1]); 
                setUploadedImageMimeType(file.type);
            };

            reader.readAsDataURL(file);
        }
    };

    // --- Core Generation Logic (1 Credit, Video Output) ---
    const generateVideo = async () => {
        // --- Pre-checks ---
        if (!uploadedImageBase64) {
            setError("Please upload a Product/UI image first.");
            return;
        }
        if (credits < VEO_SYNTHESIS_COST) {
            setError(`Insufficient credits. Need ${VEO_SYNTHESIS_COST} credit to generate the video.`);
            return;
        }

        setGenerating(true);
        setError("");
        setSuccess("");
        setGeneratedVideoOutput(""); 

        try {
            // 1. Deduct Credit (1 credit total for the whole process)
            const deductResponse = await axios.post(
                `https://octoberfour-60f2c682a1d1.herokuapp.com/api/deduct-credit`,
                { userEmail: user.email, amount: VEO_SYNTHESIS_COST }
            );
            if (!deductResponse.data.success) {
                throw new Error("Failed to deduct credit");
            }
            setCredits((prev) => prev - VEO_SYNTHESIS_COST);
            setSuccess(`1 Credit deducted. Requesting video generation from the Veo 3 model...`);

            // 2. Prepare and Call Gemini API (Used for intelligent planning/scripting)
            const API_URL = `https://generativelanguage.googleapis.com/v1/models/${GEMINI_PLANNING_MODEL}:generateContent?key=${getRandomApiKey()}`;

            const durationRange = selectedVideoStyle.includes("Short") ? "8-10 seconds" : "30-60 seconds";
            
            // PROMPT: Guides Gemini to create a plan that a Video Generation API would use
            const prompt = `
You are the **Intelligent Planning Unit** for the Veo 3 Video Generator (Model ID: ${VEO_GENERATION_MODEL_ID}). Your task is to analyze the user's uploaded product image and generate the precise JSON blueprint for a **${selectedVideoStyle}** video. The final video must visually showcase the uploaded product/UI based on the description and style, using the image as the core visual asset.

INPUT:
- Video Style/Type: ${selectedVideoStyle} 
- Custom Instructions: ${customPrompt || "Focus on the main features visible in the image."}
- Product/UI Image (source of inspiration for visuals)

OUTPUT (JSON ONLY, Total duration must be approximately **${durationRange}**):
{
    "title": "A compelling title for the video.",
    "target_duration": "${durationRange}",
    "script_instructions": [
        {
            "scene": 1,
            "visuals": "Detailed camera movement and shot description focusing on the product image. E.g., 'Smooth, rotating 3D composite of the UI on a dark background. Highlight the button marked 'X' with a glow effect.'",
            "voiceover": "First line of narration or text overlay.",
            "sound_design": "Upbeat music starts with a subtle digital whoosh.",
            "duration": "4 seconds"
        }
    ],
    "notes": "Ensure the tone is professional and engaging."
}

REQUIREMENTS:
1. Provide the output as a clean **JSON block only**, without any surrounding text or markdown.
2. The visuals in 'script_instructions' MUST reference and describe elements from the uploaded image.
`;

            // The image (Base64) is sent as inlineData to the Gemini API
            const contents = [
                { role: "user", parts: [{ text: prompt }, { inlineData: { mimeType: uploadedImageMimeType, data: uploadedImageBase64 } }] },
            ];

            const response = await fetch(API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ contents: contents }),
            });

            if (!response.ok) {
                throw new Error(`API Error during script generation: ${response.status}`);
            }

            const data = await response.json();
            const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;
            // Use a regex to robustly extract the JSON block
            const jsonMatch = rawText?.match(/\{[\s\S]*\}/); 
            const jsonString = jsonMatch ? jsonMatch[0] : null;

            if (!jsonString) {
                throw new Error("Generated text did not contain a valid JSON script.");
            }
            
            // const generatedScript = JSON.parse(jsonString); // Stored for debugging/display if needed

            // --- 3. Simulate Video Synthesis (Backend Call to Veo 3 would happen here) ---
            setSuccess(`Blueprint created. Simulating ${VEO_GENERATION_MODEL_ID} visual synthesis (Wait Time: ~5 seconds)...`);
            await new Promise(resolve => setTimeout(resolve, 5000)); // Simulate generation time

            // Generate a "unique" (but still mock) URL to make it feel more real
            const uniqueMockVideoUrl = `http://generated-video-cdn.com/veo3-user-${user.uid}-video-${Date.now()}.mp4`;
            
            // This URL would be the actual video path returned by your backend/Veo 3 service
            setGeneratedVideoOutput(uniqueMockVideoUrl); 
            setSuccess(`✅ Video generation complete! Your unique video is ready.`);

        } catch (err) {
            console.error(err);
            setError(`Video Generation Failed: ${err.message}. ${VEO_SYNTHESIS_COST} credit refunded.`);
            
            // Refund the credit on failure
            try {
                await axios.post(`https://octoberfour-60f2c682a1d1.herokuapp.com/api/refund-credit`, { userEmail: user.email, amount: VEO_SYNTHESIS_COST });
                setCredits((prev) => prev + VEO_SYNTHESIS_COST);
            } catch (refundErr) {
                console.error("Failed to refund credit:", refundErr);
            }
        } finally {
            setGenerating(false);
        }
    };

    // --- UI Rendering Logic ---
    const renderPreview = () => {
        if (generating) {
            // Show custom loading animation during generation
            return (
                <div className="text-center py-5">
                    <div className="ai-generating-animation">
                        <div className="ai-icon mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-12 h-12">
                                <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286l-11.54 6.347c-1.25.687-2.779-.216-2.779-1.643V5.653z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <p className="text-muted">Veo 3 is synthesizing the visual video from your image...</p>
                        <div className="ai-dots"><span></span><span></span><span></span></div>
                    </div>
                </div>
            );
        }

        // Display a uniquely generated mock video URL
        if (generatedVideoOutput.startsWith('http')) {
            return (
                <div className="text-center p-3">
                    <div className="video-player-frame">
                        {/* NOTE: This video element will try to load the unique mock URL. 
                            Since it's a mock URL, the video content will likely fail to load 
                            or show a generic placeholder if your browser caches the domain/URL. 
                            
                            FOR REAL TESTING: You can replace `generatedVideoOutput` with a publicly accessible MP4 URL.
                            e.g., src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" 
                        */}
                        <video 
                            controls 
                            autoPlay 
                            muted 
                            loop
                            src={generatedVideoOutput} 
                            className="img-fluid rounded" 
                            style={{ width: '100%', maxHeight: '400px', backgroundColor: '#000' }}
                        >
                            Your browser does not support the video tag.
                        </video>
                        <p className="mt-2 text-success fw-bold">Video generation complete! (Using placeholder content for demonstration)</p>
                        <p className="text-muted small">
                            To see your custom image in the video, a robust backend integration with a real video AI service is required.
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className="text-center text-muted py-5">
                <p>The final synthesized video will appear here.</p>
            </div>
        );
    };

    // --- Loading/Auth Checks ---
    if (loadingAuth || loading || loadingKeys)
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );

    if (!user)
        return (
            <div className="container text-center py-5">
                <h2>Please log in to use the Image to Video AI tool</h2>
                <button className="btn btn-primary mt-3" onClick={() => (window.location.href = "/login")}>
                    Go to Login
                </button>
            </div>
        );

    // --- Main Render ---
    return (
        <div className="container py-5">
            <div className="row g-4">
                <div className="col-lg-8 mx-auto">
                    <div className="card shadow-lg p-4">
                        <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
                            Image to <span style={{ color: "#00bfa5" }}>Generate Video AI 🎬</span>
                        </h2>
                        <h4 className="mb-4 text-black">Remaining Credits: <span className="text-primary">{credits}</span></h4>
                        <p className="text-muted mb-3">**Video Generation Cost: {VEO_SYNTHESIS_COST} Credit Total**</p>

                        {credits < VEO_SYNTHESIS_COST && (
                            <button className="btn btn-danger btn-sm mb-3" onClick={() => navigate("/user/select-package")}>
                                Buy More Credits
                            </button>
                        )}
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}

                        {/* --- Input Section --- */}
                        <div className="mb-3 mt-3">
                            <label className="form-label fw-bold">1. Upload Product/UI Image *</label>
                            <input
                                id="image-upload-input"
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleImageUpload}
                                disabled={generating}
                            />
                            {uploadedImageUrl && (
                                <div className="mt-3 text-center border p-2 rounded bg-light">
                                    <img
                                        src={uploadedImageUrl}
                                        alt="Uploaded Preview"
                                        className="img-fluid rounded"
                                        style={{ maxHeight: "150px" }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">2. Select Video Style/Type</label>
                            <select
                                className="form-select"
                                value={selectedVideoStyle}
                                onChange={(e) => setSelectedVideoStyle(e.target.value)}
                                disabled={generating}
                            >
                                <option value="Social Media Ad (Short)">Social Media Ad (Short)</option>
                                <option value="Cinematic Trailer">Cinematic Trailer</option>
                                <option value="Product Demo">Product Demo</option>
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="form-label fw-bold">
                                3. Custom Instructions (Optional)
                            </label>
                            <textarea
                                className="form-control"
                                value={customPrompt}
                                onChange={(e) => setCustomPrompt(e.target.value)}
                                placeholder="e.g., Target audience, specific mood, or features to highlight."
                                rows={2}
                                disabled={generating}
                            />
                        </div>

                        <div className="d-grid gap-2 mb-4">
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={generateVideo}
                                disabled={generating || !uploadedImageBase64 || credits < VEO_SYNTHESIS_COST}
                            >
                                {generating ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Generating Visual Video...
                                    </>
                                ) : (
                                    `Generate Final Video (${VEO_SYNTHESIS_COST} Credit)`
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- Output Section --- */}
            <div className="row g-4 mt-2">
                <div className="col-lg-8 mx-auto">
                    <div className="card shadow-lg p-4">
                        <h5 className="m-0 mb-3 text-primary">Video Preview & Download</h5>
                        
                        {renderPreview()}

                        {generatedVideoOutput.startsWith('http') && (
                            <div className="mt-4 pt-3 border-top text-center">
                                <a
                                    href={generatedVideoOutput}
                                    className="btn btn-success btn-sm"
                                    download={`generated_video_${Date.now()}.mp4`} // Unique filename for download
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Download Final Video (.mp4)
                                </a>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            {/* --- Style Block (CSS for Animations/Layout) --- */}
            <style jsx>{`
                .video-player-frame {
                    width: 100%;
                    aspect-ratio: 16/9; 
                    background-color: #000;
                    border-radius: 8px;
                    margin: 20px auto 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
                }
                .ai-icon svg { width: 4rem; height: 4rem; color: #00bfa5; animation: pulse 2s infinite; }
                @keyframes pulse { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 1; } }
                .ai-dots { display: flex; justify-content: center; margin-top: 10px; }
                .ai-dots span { width: 10px; height: 10px; background-color: #00bfa5; border-radius: 50%; margin: 0 5px; display: inline-block; animation: bounce 1.4s infinite ease-in-out both; }
                .ai-dots span:nth-child(1) { animation-delay: -0.32s; }
                .ai-dots span:nth-child(2) { animation-delay: -0.16s; }
                @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
            `}</style>
        </div>
    );
};

export default ProductPhotographyVideoAI;